export default {
    install: (app: any) => {
        window.trans = app.config.globalProperties.$t;
    }
}
